import axios from '@/plugins/axios'
import { Endpoints, urlBuilder } from '@/connectors/endpoints'
import { IPersonalAccountImportGisGkh } from '@/types/personal-accounts'

const importPersonalAccountGisGkh = (formData: IPersonalAccountImportGisGkh) => {
  return axios.post(urlBuilder(Endpoints.IMPORT_PERSONAL_ACCOUNT_GIS_GKH), formData)
}

export default importPersonalAccountGisGkh
